var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCruceroIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 83,
    height: 62,
    viewBox: "0 0 83 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_20",
    "data-name": "Rect\\xE1ngulo 20",
    width: 83,
    height: 62,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7",
    "data-name": "Grupo 7",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_51",
    "data-name": "Trazado 51",
    d: "M0,47.468C.2,46.744.36,46,.618,45.3A1.842,1.842,0,0,1,2.37,43.957a27.146,27.146,0,0,0,10.881-2.9c5.563-2.566,11.053-5.289,16.587-7.918a127.77,127.77,0,0,1,32.1-10.677A125.792,125.792,0,0,1,80.375,20.6,2.439,2.439,0,0,1,83,22.046v1.619a7.013,7.013,0,0,0-.155.789,46.036,46.036,0,0,1-6.191,19.759,56.589,56.589,0,0,1-3.975,5.7c-1.38,1.8-2.056,4.439.275,6.41a6.677,6.677,0,0,1,2.161,4.33c.132.921-.287,1.388-1.224,1.342s-1.885-.133-2.828-.2L53.934,60.568l-16.645-1.19L20,58.141q-8-.573-16-1.152a2.911,2.911,0,0,1-2.555-1.733,13.313,13.313,0,0,1-.8-2.2c-.264-.986-.432-2-.642-3V47.468",
    fill: "#20221d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_52",
    "data-name": "Trazado 52",
    d: "M66.612,14.2c.12-2.222-.6-3.372-2.513-4.07a25.5,25.5,0,0,0-7.248-1.195,29.472,29.472,0,0,0-17.112,4.226C30.909,18.334,22,23.376,13.656,29.33A3.944,3.944,0,0,0,11.9,32.013c-.31,1.863-.733,3.707-1.013,5.573a1.746,1.746,0,0,1-1.4,1.626c-.926.255-1.83.594-2.915.952.056-.55.067-.911.132-1.262q.712-3.86,1.444-7.716a7.7,7.7,0,0,1,3.36-5.045c6.52-4.539,13.208-8.81,20.142-12.691C34.9,11.63,38.1,9.7,41.417,8.019A29.772,29.772,0,0,1,57.493,5.168a66.484,66.484,0,0,1,6.871,1.039,10.368,10.368,0,0,1,2.491.943,5.14,5.14,0,0,1,3.162,3.91c.357,2.014.953,3.987,1.48,5.968.172.649.027.923-.672,1.022a14.213,14.213,0,0,1-4.894-.117,42.746,42.746,0,0,0-13.611-.776A28.464,28.464,0,0,0,42.9,19.993q-11.05,5.524-22.078,11.1c-.238.119-.479.232-.724.352a2.488,2.488,0,0,1,1.078-3.021Q31.586,22.465,42,16.52A28.984,28.984,0,0,1,59.13,13.081c2.253.186,4.481.671,6.721,1.017.234.036.47.062.762.1",
    fill: "#fdb54e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_53",
    "data-name": "Trazado 53",
    d: "M20.815,16.067c-.021-.42-.047-.711-.047-1,0-3.265.019-6.53-.013-9.795A3.681,3.681,0,0,1,21.993,2.4,9.16,9.16,0,0,1,27.428.118,24.158,24.158,0,0,1,31.615.065,2.686,2.686,0,0,1,33.978,1.9c.635,1.518,1.335,3.009,2.031,4.5.217.466.208.774-.289,1.063q-7.172,4.184-14.329,8.4a4.223,4.223,0,0,1-.577.211",
    fill: "#fdb54e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_54",
    "data-name": "Trazado 54",
    d: "M60.129,36.13c0,2.817-1.887,5.1-4.215,5.1S51.7,38.946,51.7,36.13s1.887-5.1,4.215-5.1,4.215,2.283,4.215,5.1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_55",
    "data-name": "Trazado 55",
    d: "M42.783,40.775c0,2.129-1.379,3.854-3.08,3.854s-3.08-1.725-3.08-3.854S38,36.921,39.7,36.921s3.08,1.725,3.08,3.854",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_56",
    "data-name": "Trazado 56",
    d: "M27.221,44.967c0,1.6-.98,2.9-2.188,2.9s-2.188-1.3-2.188-2.9.98-2.9,2.188-2.9,2.188,1.3,2.188,2.9",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_57",
    "data-name": "Trazado 57",
    d: "M13.537,48.515c0,1.162-.711,2.1-1.588,2.1s-1.588-.942-1.588-2.1.711-2.1,1.588-2.1,1.588.942,1.588,2.1",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCruceroIcon);
export default __webpack_public_path__ + "static/media/cruceroIcon.49a76e8f51a9ddb1c8b044ea535a3daf.svg";
export { ForwardRef as ReactComponent };